import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Tenant } from './api'

interface AuthState {
  token: string | null
  tenant: Tenant | null
  role: string | null
  /** 'active' | 'pending' | 'invited' — 'pending' means logged in but awaiting admin approval */
  status: string | null
  setAuth: (token: string, tenant: Tenant | null, role?: string | null, status?: string | null) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token:  null,
      tenant: null,
      role:   null,
      status: null,
      setAuth: (token, tenant, role = null, status = 'active') => {
        set({ token, tenant, role, status })
      },
      clearAuth: () => {
        set({ token: null, tenant: null, role: null, status: null })
      },
    }),
    { name: 'scion-auth' }
  )
)
